export default __webpack_public_path__ + "static/media/logo-negativa.ed2dfe6c.svg";